import React, {useEffect, useState} from "react";
import {Button, Flex, message, Spin, Typography} from "antd";
import * as API_BOOKS from '../../../../../shared/http/books';
import {BookMark} from "../../../../../shared/types/api";
import {useParams} from "react-router-dom";
import {BookOutlined} from "@ant-design/icons";
import BookmarksItem from "./BookmarksItem";

interface BookmarksTabProps {
    readChars: number;
    openBookMark: (offset: number) => void
}

const {Title, Text} = Typography;

const BookmarksTab: React.FC<BookmarksTabProps> = ({readChars, openBookMark}) => {
    const [bookmarks, setBookmarks] = useState<BookMark[]>([]);

    const [bookMarkCreateLoading, setBookMarkCreateLoading] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const {id} = useParams()


    useEffect(() => {
        getUserBookmarks()
    }, []);


    const getUserBookmarks = async () => {
        setLoading(true)
        try {
            const {data} = await API_BOOKS.getBookmarks(Number(id));
            if (data.content) {
                const bookmarksWithFormattedTime = data.content.map((bookmark: BookMark) => {
                    const date = new Date(bookmark.localTime);

                    const formattedTime = date.toLocaleString('ru-RU', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                    });

                    return {
                        ...bookmark,
                        formatedTime: formattedTime,
                    };
                });

                setBookmarks(bookmarksWithFormattedTime);
            }
        } finally {
            setLoading(false)
        }

    }

    const handleAddBookmark = async () => {
        try {
            setBookMarkCreateLoading(true)
            const localTime = new Date().toISOString();
            const {data} = await API_BOOKS.createBookmark(Number(id), "note", readChars, localTime);
            const date = new Date(data.localTime);
            data.formatedTime = date.toLocaleString('ru-RU', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
            setBookmarks((prev) => [...prev, data]);
            message.success("Закладка добавлена");
        } catch (e) {
            message.error("Не удалось сохранить закладку");
        } finally {
            setBookMarkCreateLoading(false)
        }

    };

    const handleRemoveBookmark = async (bookMarkId: number) => {
        const updated = bookmarks.filter((item, i) => item.id !== bookMarkId);
        setBookmarks(updated);
        message.info("Закладка удалена");
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 24,
                }}
            >
                <Button
                    type="primary"
                    icon={<BookOutlined/>}
                    size="middle"
                    onClick={handleAddBookmark}
                    loading={bookMarkCreateLoading}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        borderRadius: 8,
                        padding: "0 20px",
                    }}
                >
                    Добавить закладку
                </Button>
            </div>

            {bookmarks.length > 0 ? (
                <Flex
                    vertical
                    gap="small"
                    style={{
                        backgroundColor: "var(--color-bg-surface)",
                        borderRadius: 12,
                        padding: 16,
                    }}>
                    {bookmarks
                        .slice()
                        .sort((a, b) => new Date(b.localTime).getTime() - new Date(a.localTime).getTime())
                        .map((item) => {
                        return (
                            <BookmarksItem item={item} openBookMark={openBookMark} handleRemoveBookmark={handleRemoveBookmark}/>
                        );
                    })}
                </Flex>
            ) : (
                <div
                    style={{
                        textAlign: "center",
                        padding: "40px 0",
                        color: "#888",
                        backgroundColor: "var(--color-bg-elevated)",
                        borderRadius: 8,
                    }}
                >
                    {loading && <Spin/>}
                    {!loading && <>
                        <BookOutlined style={{fontSize: 32, marginBottom: 8, color: "#bbb"}}/>
                        <Title level={5}>Закладок пока нет</Title>
                        <Text type="secondary">Добавьте первую закладку в книге 📚</Text>
                    </>}
                </div>
            )}
        </>
    );
};

export default BookmarksTab;
